/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, inject, LOCALE_ID} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ToolbarComponent} from '../toolbar/toolbar.component';
import {RouterLink} from '@angular/router';
import {MatTooltip} from '@angular/material/tooltip';
import {XmlExportComponent} from '../../shared/xml-export/xml-export.component';
import {NgClass} from '@angular/common';

@Component({
    selector: 'elohn-default-toolbar',
    templateUrl: './default-toolbar.component.html',
    styleUrls: ['./default-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ToolbarComponent, RouterLink, MatTooltip, XmlExportComponent, NgClass]
})
export class DefaultToolbarComponent {

    public locale = inject(LOCALE_ID);

    public readonly appVersion = environment.version;

    setLocationPathname(locationPathname: string): void {
        localStorage.setItem('locationPathname', locationPathname);
    }
}
